export default "__VITE_ASSET__CXT3QINj__"